module.exports = __webpack_public_path__ + "media/images/flags/64/Slovakia-1d2660c34fee8d43dd66f1053766f450.png";